import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';

import { Button } from '@/common/components/ui/button';

export const UnknownRoute = () => {
  const { t } = useTranslation();

  return (
    <main className="flex flex-col items-center justify-center h-screen gap-10">
      <h1 className="text-2xl font-semibold">{t('app.404')}</h1>

      <Button asChild>
        <RouterLink to="/">{t('app.returnToHome')}</RouterLink>
      </Button>
    </main>
  );
};
